import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { staticHead } from '../lib/seo';
import { getStaticPage } from '../lib/static-content';

export const Route = createFileRoute('/advertising')({
  head: () => {
    const p = getStaticPage('advertising');
    return staticHead({ pathname: '/advertising', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="advertising" />,
});
